export const theme = {
  // Calm dark palette (Quo-like): neutral charcoal, low-contrast borders, soft gold accents.
  colors: {
    bg0: '#0b0c0f',
    bg1: '#0f1116',

    panel: '#12141a',
    panel2: '#0f1116',

    text: '#e9edf3',
    muted: '#a7b0bf',

    // Accent (gold) kept subtle; avoid loud yellows.
    gold: '#c8ad6a',
    gold2: '#ad8b3f',

    // Lines / dividers
    line: 'rgba(255,255,255,0.06)',
    lineGold: 'rgba(200,173,106,0.18)',

    danger: '#ff5c7a',
    ok: '#38d996'
  },
  radius: {
    sm: '12px',
    md: '18px'
  },
  shadow: {
    soft: '0 1px 2px rgba(0,0,0,0.20), 0 8px 20px -6px rgba(0,0,0,0.28), 0 28px 64px -16px rgba(0,0,0,0.40)'
  }
} as const;
